import { Children, cloneElement, isValidElement, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { propStyling, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = ({
  children,
  className = '',
  initialTabIndex = 0,
  onClick,
  ...rest
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(initialTabIndex);
  useEffect(() => {
    setActiveTabIndex(initialTabIndex);
  }, [initialTabIndex]);
  const handleTabClick = tabIndex => {
    setActiveTabIndex(tabIndex);
  };
  const renderTabsList = () => {
    return Children.map(children, (child, index) => {
      return /*#__PURE__*/isValidElement(child) ? /*#__PURE__*/cloneElement(child, {
        onClick: handleTabClick,
        tabIndex: index,
        isActive: index === activeTabIndex
      }) : null;
    });
  };
  const renderActiveTabContent = () => {
    if (children[activeTabIndex]) {
      return children[activeTabIndex].props.children;
    }
  };
  return /*#__PURE__*/_jsxs(StyledTabs, {
    className: `Tabs ${className}`,
    ...rest,
    "data-sentry-element": "StyledTabs",
    "data-sentry-component": "Tabs",
    "data-sentry-source-file": "Tabs.tsx",
    children: [/*#__PURE__*/_jsx("ul", {
      className: "Tabs_nav",
      children: renderTabsList()
    }), /*#__PURE__*/_jsx("div", {
      className: "Tabs_activeContent",
      children: renderActiveTabContent()
    })]
  });
};
const Tab = ({
  isActive,
  onClick,
  tabIndex,
  tabContent,
  onChangeTab
}) => {
  const handleTabClick = event => {
    event.preventDefault();
    onClick(tabIndex);
    onChangeTab && onChangeTab(tabIndex);
  };
  return /*#__PURE__*/_jsx(StyledListElement, {
    className: `${isActive ? 'isActive' : ''}`,
    onClick: handleTabClick,
    isActive: isActive,
    "data-sentry-element": "StyledListElement",
    "data-sentry-component": "Tab",
    "data-sentry-source-file": "Tabs.tsx",
    children: tabContent
  });
};
const StyledListElement = styled.li.withConfig({
  displayName: "Tabs__StyledListElement"
})(["", " font-weight:bold;margin-bottom:-3px;list-style:none;margin-right:", ";", ";&:hover{cursor:pointer;}", ""], tombac.altText(), tombac.space(3), ({
  isActive
}) => isActive ? css(["border-bottom:", ";"], tombac.parse('3u solid --primary-500')) : undefined, propStyling);
const StyledTabs = styled.div.withConfig({
  displayName: "Tabs__StyledTabs"
})([".Tabs_nav{all:initial;display:flex;padding:0;border-bottom:", ";margin:", ";}", ""], tombac.parse('3u solid --neutral-500'), tombac.space(3, 0), propStyling);
export { Tabs, Tab };